module.exports = __webpack_public_path__ + "static/img/onekey_logo.be747120.png";